/** EN uses Swedish values until translated. */
export const chartsCommonEn = {
    legend: {
        currentPeriod: 'Current period',
        oneYearAgo: '1 year ago',
        futureAndOngoingRightsIssues: 'Current and upcoming rights issues',
    },
    table: {
        quarter: 'Quarter',
        countAverage: 'Amount (mean)',
        count: 'Amount',
    },
    units: {
        st: 'pcs',
    },
}
